<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-md">
            <div class="td-cnt-title">
                <span class="te-title">{{ 'itdcr.itdcrAttachments' | translate}}</span>
            </div>
            <div class="td-cnt-body">
                <div style="width: 100%;display: flex;flex-direction: column;">
                    <!-- Accordion view -->
                    <mat-accordion *ngIf="attachmentGroups?.length; else noData" multi>
                        <mat-expansion-panel *ngFor="let group of attachmentGroups">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ group.label }}
                                </mat-panel-title>
                                <mat-panel-description>
                                    <mat-chip-set>
                                        <mat-chip>{{ group.items.length }}</mat-chip>
                                    </mat-chip-set>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <!-- List of files -->
                            <mat-list role="list">
                                <mat-list-item role="listitem" *ngFor="let att of group.items; trackBy: trackByAtt">
                                    <div class="file-download">
                                        <div matListItemTitle class="file-title" [title]="att.fileName"
                                            [ngClass]="{'is-in-deletion': isMarkedForDeletion(att)}">
                                            <span class="ml-8">{{ att.fileName }}</span>
                                        </div>
                                        <div matListItemLine class="file-meta">
                                            <span class="date">
                                                {{ att.fileDate ? (att.fileDate | date:'short') : '' }}
                                            </span>
                                        </div>
                                        <button mat-stroked-button class="ml-auto" (click)="downloadExisting(att)">
                                            <span class="ml-4">{{ 'commons.donwload' | translate }}</span>
                                        </button>
                                        <button *ngIf="!readOnly && isItdcrAttachment(att) && att.canBeDeleted" mat-stroked-button class="ml-4"
                                            (click)="toggleDeleteExisting(att)">
                                            <ng-container *ngIf="isMarkedForDeletion(att); else deleteIcon">
                                                <i class="fal fa-trash-undo ml-4"></i>
                                            </ng-container>
                                            <ng-template #deleteIcon>
                                                <i class="fal fa-trash-alt ml-4"></i>
                                            </ng-template>
                                        </button>
                                    </div>
                                </mat-list-item>
                            </mat-list>

                            <mat-divider></mat-divider>


                        </mat-expansion-panel>
                    </mat-accordion>

                    <ng-template #noData>
                        <div style="opacity: .7; padding: 8px 0;">
                            {{ 'commons.noAttachments' | translate }}
                        </div>
                    </ng-template>

                    <ng-container *ngIf="!readOnly">
                        <!-- New uploads -->
                        <input type="file" multiple class="file-upload" (change)="addNewFiles($event)"
                            style="display: none;" id="itdcrFileUploadAttach">
                        <teiasoft-button (onClick)="onAddAttachmentClick()" class="mr-5" [type]="'tb-primary'"
                            [text]="'commons.attachFile' | translate" [theme]="theme" [isMobile]="isMobile"
                            style="margin-top: 1.2rem;margin-bottom: 1.2rem;"></teiasoft-button>
                    </ng-container>
                    <div>
                        <div style="display:flex; flex-direction:column; gap:8px;">
                            <div *ngFor="let na of newAttachments; let i = index"
                                style="display:flex; align-items:center; gap:12px;">
                                <i class="fal fa-trash-alt tg-custom-icon" (click)="removeNewAttachment(i)"
                                    style="cursor: pointer;"></i>
                                <span>{{ na.fileName }}</span>
                                <span style="opacity:.7;">{{ na.fileCreationDate | date:'short' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.close' | translate"
                    class="mr-5"></teiasoft-button>

                <teiasoft-button *ngIf="!readOnly" (click)="onSaveClick()" [type]="'tb-primary'"
                    [text]="'commons.save' | translate" class="mr-5" [disabled]="!hasPendingChanges"></teiasoft-button>
            </div>
        </div>

    </div>
</div>
